// extracted by mini-css-extract-plugin
export default {"salonSelectAndHome":"SalonSelectAndHome_salonSelectAndHome__omaGg","homeButton":"SalonSelectAndHome_homeButton__ITCkC"};